<template>
  <div>
    <!-- 分销工作台 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="navFrame">
      <div class="navDataBig">
        <div v-for="v in navList" :key="v.id" @click="noteTem(v.id)">
          <div>{{v.title}}</div>
          <div>
            <span>
              <span>{{v.navTotal}}</span>
              <span>{{v.unit}}</span>
            </span>
            <img :src="v.srcUrl" alt />
          </div>
        </div>
      </div>
    </div>
    <!-- <el-card class="card"> -->
    <div class="card">
      <div class="cardDiv">
        <div>
          <div>
            <span>消息</span>
            <span class="setCur" @click="AllMsg()">全部信息></span>
          </div>
          <ul v-for="v in ulNote" :key="v.id" class="ul" @click="infoFn(v)">
            <li>
              <div>
                <img
                  style="width:17px;height:15px;vertical-align: middle;"
                  src="../../images/distributor/dxh.png"
                  alt
                  srcset
                  v-if="v.State==2"
                />
                <img
                  style="width:17px;height:15px;vertical-align: middle;"
                  src="../../images/distributor/dxl.png"
                  alt
                  srcset
                  v-if="v.State==1"
                />
                <span>{{v.FromUserID=='0'?'金飞鹰系统':'系统'}}</span>
                <span>{{v.MailContent}}</span>
                <span>{{v.tip3}}</span>
              </div>
              <div>{{v.CreateTime}}</div>
            </li>
          </ul>
        </div>
        <div class="cardRight">
          <div class="contentTwo">
            <div>基础设置</div>
            <el-divider></el-divider>
            <div class="TwoForm">
              <el-form v-model="form" :rules="rule">
                <el-form-item >
                  <span class="formnames">接口地址:</span>
                  <!-- <el-input disabled value="旧：http://api.softykt.net/Api1_0"></el-input> -->
                  <el-input style="margin-top:1rem;" disabled value="新：http://xwt.softykt.net/api/orderapi"></el-input>
                </el-form-item>
                <el-form-item >
                  <span class="formnames">APPID:</span>
                  <el-input disabled v-model="form.UserCode" placeholder="APPID"></el-input>
                </el-form-item>
                <el-form-item >
                  <span class="formnames">softyktsecrect:</span>
                  <el-input disabled v-model="form.Diskey" placeholder="--" :type='show?"text":"password"'></el-input>
                </el-form-item>
                <el-form-item class="itemBtn">
                  <el-button @click="changePass">{{ show?'隐藏':'查看' }}</el-button>
                  <el-button @click="suiji">生成秘钥</el-button>
                </el-form-item>
              
                <el-form-item label="回调Url:"  prop="url">
                  <el-input v-model="form.AgainUrl" placeholder="--"></el-input>
                </el-form-item>
                <el-form-item class="itemBtn copyClick">
                  <el-button  @click="yanzheng">保存配置信息</el-button>
                </el-form-item>
                <span   class="txt_span"  @click="copys">复制配置信息</span>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </el-card> -->
    <!-- 订单详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="noteDialogVisible"
      :before-close="noteHandleClose"
      width="73.6%"
      center
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="form">
        <div class="formItem">
          <el-form-item label="订单号:" class="three">
            <el-input v-model="form.name" placeholder="订单号"></el-input>
          </el-form-item>
          <el-form-item label="分销商:" class="three">
            <el-input v-model="form.name" placeholder="分销商"></el-input>
          </el-form-item>
          <el-form-item label="成交时间:" class="four">
            <el-input v-model="form.name" placeholder="成交时间"></el-input>
          </el-form-item>
          <el-form-item label="订单总额:" class="four">
            <el-input v-model="form.name" placeholder="订单总额"></el-input>
          </el-form-item>
          <el-form-item label="验证码:" class="three">
            <el-input v-model="form.name" placeholder="验证码"></el-input>
          </el-form-item>
        </div>
      </el-form>

      <el-table
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column prop="date" label="选择"></el-table-column>
        <el-table-column prop="name" label="产品名称"></el-table-column>
        <el-table-column prop="address" label="购买数量"></el-table-column>
        <el-table-column prop="address" label="已兑数量"></el-table-column>
        <el-table-column prop="address" label="可用数量"></el-table-column>
        <el-table-column prop="address" label="有效期"></el-table-column>
        <el-table-column prop="address" label="验票数量"></el-table-column>
      </el-table>
      <div class="btns">
        <el-button>打印</el-button>
        <el-button class="btnL" @click="checkTicFn()">验票</el-button>
      </div>
    </el-dialog>
    <!-- 订单详情弹框结束 -->

    <!-- 小票预览弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="小票打印预览"
      :visible.sync="printDialogVisible"
      :before-close="printHandleClose"
      width="25.1%"
      center
    >
      <el-divider></el-divider>
      <div class="conentCenter">
        <div class="printImg">
          <img style="width:400px;height:492px;" src="../../images/scenic/xpyl.png" alt />
        </div>
        <div class="printContent">
          <div>订单核销</div>
          <div>
            <el-descriptions :column="1" colon>
              <el-descriptions-item label="验票时间">kooriookami</el-descriptions-item>
              <el-descriptions-item label="订单号" class="order">18100000000</el-descriptions-item>
              <el-descriptions-item label="分销商">苏州市</el-descriptions-item>
              <el-descriptions-item label="商品名称">苏州市</el-descriptions-item>
              <el-descriptions-item label="本次兑换">苏州市</el-descriptions-item>
              <el-descriptions-item label="购买数量">苏州市</el-descriptions-item>
              <el-descriptions-item label="剩余数量">苏州市</el-descriptions-item>
              <el-descriptions-item label="验证日期">苏州市</el-descriptions-item>
              <el-descriptions-item label="来源">苏州市</el-descriptions-item>
              <el-descriptions-item label="签名">苏州市</el-descriptions-item>
            </el-descriptions>
          </div>
          <div>注意事项:(核销成功后,需在收银台交付押金)</div>
        </div>
      </div>

      <div class="btn">
        <el-button>打印</el-button>
      </div>
    </el-dialog>
    <!-- 小票预览弹框结束 -->

    <!-- 短信详情
     -->
     <el-dialog :close-on-click-modal="false"
      title="消息详情"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="630px"
      center
    >
      <el-divider></el-divider>

      <el-form ref="form" :model="forms" label-width="80px">
        <div class="formItem">
          <div class="itemOne">
            <el-form-item label="来自于:" class="three">
              <el-input v-model="forms.name" placeholder="来自于"></el-input>
            </el-form-item>
            <el-form-item label="收件时间:" class="three">
              <el-date-picker v-model="forms.CreateTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="消息内容:" class="four">
            <el-input
              type="textarea"
              :autosize="{minRows:5,maxRows:7}"
              v-model="forms.MailContent"
              disabled
              placeholder="消息内容"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item class="itemBtn">
            <el-button class="btnL" @click="checkTicFn()">确认</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {getDistrbutorOrderCount,getDistrbutorNewMailList,getDistrbutorNewMailInfo,getDistributorDetail,
  setDistributorApiAccount} from "@/request/distributor.js"
export default {
  data() {
    return {
      infoDialogVisible:false,
      value: new Date(),
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ],
      value1: "",
      forms: {
   
      },
      noteDialogVisible: false, // 订单详情
      printDialogVisible: false, // 小票打印预览
      value: new Date(),
      ulNote: [
      ],
      navList: [
        {
          id: 3,
          title: "今日核销",
          navTotal: 0,
          srcUrl: require("../../images/distributor/yd.png"),
          unit: "单"
        },
        {
          id: 4,
          title: "昨日订单",
          navTotal: 0,
          srcUrl: require("../../images/distributor/hx.png"),
          unit: "单"
        },
        {
          id: 5,
          title: "分销商余额",
          navTotal: 0,
          srcUrl: require("../../assets/cv.png"),
          unit: "元"
        }
      ],
      form: {
        AgainUrl:''
      },
      Diskey:'',
      AgainUrl:'',
      show:false,
      rule:{
        url: [
          {type: 'url', message: `请输入正确的url`, trigger: 'change'}
        ]
      },
    };
  },
  created(){
    this.getCountList()
    this.getNewMain()
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    getDistributorDetail(data).then(res=>{
      if(res.data.status=='ok'){
       this.navList[2].navTotal = res.data.result.Balance
      }
    })
    this.getList()
  },
  methods: {
    getList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      getDistributorDetail(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = res.data.result
          // this.form.sms_flag  = this.form.sms_flag + ''
          this.Diskey = res.data.result.Diskey
          this.AgainUrl = res.data.result.AgainUrl
        }
      })
    },
    copys(){
      let oInput = document.createElement('input');
      oInput.value =`新版接口地址：http://xwt.softykt.net/api/orderapi ; APPID: ${this.form.UserCode} ; softyktsecrect：${this.form.Diskey} ; 回调URL：${this.form.AgainUrl}`;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.success('复制成功')
    },
    yanzheng(){
      if(this.Diskey==this.form.Diskey&&this.AgainUrl==this.form.AgainUrl){
        this.$message.error('数据未发生变化，禁止验证')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        softyktsecrect:this.form.Diskey,
        notify_url:this.form.AgainUrl
      }
      setDistributorApiAccount(data).then(res=>{
          if(res.data.status =='ok'){
            this.$message.success('成功')
          }else{
              this.$message.error(res.data.msg);
          }
      })
    },
      // 随机获取 验证
    suiji(){
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      var maxPos = chars.length;
      let num = ''
      for (let i = 0; i < 32; i++) {
         num += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      this.form.Diskey = num
      let data = {
        token:window.sessionStorage.getItem('Token'),
        softyktsecrect:this.form.Diskey,
        notify_url:this.form.AgainUrl
      }
      setDistributorApiAccount(data).then(res=>{
          if(res.data.status =='ok'){
            this.$message.success('成功')
          }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    changePass(){
      this.show = !this.show
    },
    infoFn(row) {
      let data = {
        token:window.sessionStorage.getItem('Token'),
        NewMailID:row.NewMailID
      }
      getDistrbutorNewMailInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.forms = res.data.result
          this.forms.name  = this.forms.FromUserID=='0'?'金飞鹰系统':'系统'
          this.infoDialogVisible = true;
          this.getNewMain()
        }
      })
    },
    infoHandleClose() {
      this.infoDialogVisible = false;
    },
    getNewMain(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8
      }
      getDistrbutorNewMailList(data).then(res=>{
        if(res.data.status=='ok'){
          this.ulNote = res.data.result.data
        }
      })
    },
    // 统计数量
    getCountList(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      getDistrbutorOrderCount(data).then(res=>{
        if(res.data.status=='ok'){
          this.navList[0].navTotal = res.data.result.yesterday_order_usecount	
          this.navList[1].navTotal = res.data.result.yesterday_order_count	

        }
      })
    },
    // 点击全部消息
    AllMsg(){
      this.$router.push('/allMsg')
    },
    // 小票打印预览
    checkTicFn() {
      this.printDialogVisible = true;
      this.noteDialogVisible = false;
    },
    // 小票打印预览X
    printHandleClose() {
      this.printDialogVisible = false;
    },
    // 订单详情
    detailFn() {
      this.noteDialogVisible = true;
    },
    // 订单详情X
    noteHandleClose() {
      this.noteDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.is-selected {
  width: 24px;
  height: 24px;
  background: #246deb;
  border-radius: 4px;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
}
/deep/.el-calendar-table tr:first-child td {
  border: none;
}
/deep/.el-calendar-table .el-calendar-day {
  box-sizing: border-box;
  padding: 0px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
/deep/.el-calendar__header {
  display: flex;
  justify-content: space-between;
  padding: 0px;
  border-bottom: 1px solid #ebeef5;
  width: 98%;
}
/deep/.el-calendar__header {
  display: flex;
  justify-content: space-between;
  padding: 0px;
  border-bottom: 0px solid #ebeef5;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}
/deep/.el-calendar-table td {
  border: none;
  vertical-align: top;
  transition: background-color 0.2s ease;
}
/deep/.el-button--mini {
  font-size: 12px;
  border-radius: 3px;
  border: none;
}
/deep/.el-button-group > .el-button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #246deb;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background-color: transparent !important;
}
/deep/.el-button-group > .el-button:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #246deb;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background-color: transparent !important;
}
/deep/.el-button-group > .el-button:not(:first-child):not(:last-child) {
  margin-left: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #ffffff;
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  background: #246deb;
}

/deep/.el-calendar__body {
  width: 105%;
  padding: 10px;
}
/deep/.el-calendar-table td.is-selected {
  width: 24px;
  height: 24px;
  background-color: transparent !important;
}
/deep/.el-calendar-table tr td:first-child {
  border-left: none;
}

.btn {
  display: flex;
  justify-content: center;
  margin: 40px 0 30px 0;
  /deep/.el-button {
    width: 100px;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    background: #ffffff;
  }
}
.conentCenter {
  .printImg {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .printContent {
    width: 400px;
    //   height: 492px;
    padding: 0 20px;
    box-sizing: border-box;
    margin: auto;
    // border: 1px double #246deb;
    position: absolute;
    top: 82px;
    left: 41px;
    > div:nth-child(1) {
      height: 64px;
      line-height: 64px;
      text-align: center;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      /* identical to box height */
      color: #000000;
      border-bottom: 2px double #c4c4c4;
    }
    > div:nth-child(2) {
      margin-top: 18px;
      /deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
        padding-bottom: 15px;
      }
      /deep/.el-descriptions-item__label {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: right;

        color: #666666;
      }
      /deep/.el-descriptions-item__content {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;

        color: #000000;
      }
    }
    > div:nth-child(3) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      margin: 10px 0 20px 0;
    }
  }
}
.btns {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  .el-button {
    width: 100px;
    height: 40px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #246deb;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;

    color: #ffffff;
  }
}

.card {
  .cardDiv {
    display: flex;
    > div:nth-child(1) {
      width: 68.8%;
      margin-right: 20px;
      padding: 0 20px 20px 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px;
      > div:nth-child(1) {
        width: 100%;
        height: 59px;
        border-bottom: 1px solid #e5e5ea;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > span:nth-child(1) {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 28px;
          /* identical to box height */

          color: #000000;
        }
        > span:nth-child(2) {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */

          color: #246deb;
        }
      }
      .ul {
        cursor: pointer;
        > li {
          width: 100%;
          height: 50px;
          margin: 20px 0;
          padding: 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e5e5ea;
          border-radius: 4px;
          > div:nth-child(1) {
            width: 85%;
            > span:nth-child(2) {
              display: inline-block;
              margin: 0 28px;
              font-family: ".PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */
              color: #000000;
            }
            > span:nth-child(3) {
              display: inline-block;
              margin-right: 28px;
              font-family: ".PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */

              color: #000000;
            }
            > span:nth-child(4) {
              display: inline-block;
              //   margin: 0 28px;
              font-family: ".PingFang SC";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              /* identical to box height */
              color: #666666;
            }
          }
          > div:nth-child(2) {
            width: 15%;
            text-align: right;
          }
        }
        > div:nth-child(2) {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */

          color: #000000;
        }
      }
    }
    .cardRight {
      width: 30%;
      height:77.6rem;
      min-width: 200px;
      .contentTwo {
        width: 100%;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 4px;
        > div:nth-child(1) {
          height: 40px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          color: #000000;
        }
        .TwoForm {
          /deep/.el-form-item__label {
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
          /deep/.el-form-item {
            margin-bottom: 1rem;
            position: relative;
          }
          .xingA {
            position: absolute;
            top: 0px;
            left: -5px;
            color: #e74c3c;
          }
          .itemBtn {
            display: flex;
            justify-content: flex-end;
            .el-button {
              background: #ffffff;
              border: 1px solid #246deb;
              border-radius: 4px;
              font-family: "OPPOSans";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              text-align: center;
              color: #246deb;
            }
          }
        }
      }
    }
  }
}
.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  .navDataBig {
    width: 100%;
    height: 150px;
    display: flex;
    > div {
      width: 25%;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 20px;
      > div:nth-child(1) {
        width: 84px;
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        img {
          width: 6rem;
          height: 6rem;
          margin-right: 20px;
          margin-left: auto;
        }
        span {
          height: 100px;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            min-width: 120px;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 40px;
            line-height: 56px;
            /* identical to box height */
            color: #246deb;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.navDataBig > div{
  min-width: 260px;
}
.formItem {
  flex-direction: column;
 .itemOne{
  display: flex;
  justify-content: space-between;
 }
}
.formnames{
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.copyClick{
  justify-content: center !important;
  margin-top: 4rem;
}
.txt_span{
  display: flex;
  justify-content: center;
  font-size: 1.4rem;
  color: red;
  cursor: pointer;
}
</style>